import React from "react";
import styles from "./QuickStartExamples.module.css";

interface QuickStartExamplesProps {
  onExampleClick: (text: string) => void; // Callback when an example is clicked
}

const QuickStartExamples: React.FC<QuickStartExamplesProps> = ({
  onExampleClick,
}) => {
  // Example texts from Figma
  const examples = [
    "Cheeseburger Rezept",
    "Vegan",
    "Unter 20 Euros",
    // Removed '...' option
  ];

  // Style mapping based on Figma frames
  const getStyle = (text: string) => {
    switch (text) {
      case "Vegan":
        return styles.exampleTagVegan;
      // case "Cheeseburger Rezept":
      // case "Unter 20 Euros":
      // No break needed here as it falls through intentionally to default
      // Removed '...' case
      default:
        return styles.exampleTagDefault;
    }
  };

  // Simplified click handler
  const handleClick = (text: string) => {
    onExampleClick(text);
  };

  return (
    <div className={styles.frame408Container}>
      {examples.map((text) => (
        <button
          key={text}
          className={`${styles.exampleTagBase} ${getStyle(text)}`}
          onClick={() => handleClick(text)}
        >
          {text}
        </button>
      ))}
    </div>
  );
};

export default QuickStartExamples;
